import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { Lock, LogOut } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const startGoogleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + '/admin';
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

const GateCard = ({ title, text, children, testId }) => (
  <div className="min-h-screen flex items-center justify-center bg-[#FDF8F5] px-4 pt-24" data-testid={testId}>
    <div className="bg-white rounded-2xl border border-[#E5E5E5] p-10 max-w-md w-full text-center shadow-sm">
      <Lock className="w-10 h-10 text-[#D97706] mx-auto mb-4" />
      <h1 className="text-3xl font-heading font-medium text-[#A0451E] mb-3">{title}</h1>
      <p className="text-sm font-body text-[#4A4A4A] mb-6">{text}</p>
      {children}
    </div>
  </div>
);

const AdminGate = ({ children }) => {
  const location = useLocation();
  const [user, setUser] = useState(location.state?.user || null);
  const [status, setStatus] = useState(location.state?.user ? 'ok' : 'checking');

  useEffect(() => {
    if (location.state?.user) return;
    axios
      .get(`${API}/auth/me`)
      .then((res) => {
        setUser(res.data);
        setStatus('ok');
      })
      .catch((err) => setStatus(err.response?.status === 403 ? 'forbidden' : 'login'));
  }, [location.state]);

  const logout = async () => {
    await axios.post(`${API}/auth/logout`).catch(() => {});
    setUser(null);
    setStatus('login');
  };

  if (status === 'checking') {
    return <div className="min-h-screen flex items-center justify-center font-heading text-[#A0451E]" data-testid="admin-auth-checking">Checking access...</div>;
  }
  if (status === 'login' || status === 'forbidden') {
    const denied = status === 'forbidden' || location.state?.denied;
    return (
      <GateCard
        testId={denied ? 'admin-access-denied' : 'admin-login'}
        title={denied ? 'Access Denied' : 'Admin Login'}
        text={denied ? 'This Google account is not authorised to access the admin dashboard. Please sign in with an authorised account.' : 'Sign in with your authorised Google account to manage appointments, articles, notices and commission rates.'}
      >
        <button onClick={startGoogleLogin} className="btn-primary w-full" data-testid="admin-google-login-btn">
          Sign in with Google
        </button>
      </GateCard>
    );
  }
  return (
    <>
      <div className="fixed bottom-4 right-4 z-40 bg-white border border-[#E5E5E5] shadow-md rounded-full pl-4 pr-2 py-2 flex items-center gap-3" data-testid="admin-user-bar">
        <span className="text-xs font-body text-[#4A4A4A]" data-testid="admin-user-email">{user?.email}</span>
        <button onClick={logout} className="inline-flex items-center gap-1 text-xs font-semibold text-white bg-[#A0451E] rounded-full px-3 py-1.5" data-testid="admin-logout-btn">
          <LogOut className="w-3.5 h-3.5" /> Log out
        </button>
      </div>
      {children}
    </>
  );
};

export default AdminGate;
